import { Modal, Form, message, Input } from 'antd';
import { APPOINTMENT_STATUSES } from 'constants/appointments';
import { updateAppointmentStatus } from 'services/api/appointments';
import { useModalStateContext, useUIDispatchContext } from 'providers/UI';
import { FC, memo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { showRestError } from 'utils/showErrorMessage';

const { TextArea } = Input;

const RejectModal: FC = () => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const { rejectAppointment: rejectAppointmentModal } = useModalStateContext();
  const { toggleModal } = useUIDispatchContext();
  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    toggleModal('rejectAppointment', false);
    form.resetFields();
  };

  const onFinish = (values: { reason: string }) => {
    const isCanceled =
      rejectAppointmentModal.params?.status === APPOINTMENT_STATUSES.canceled;

    setLoading(true);
    // REJECTED/CANCELED both route to PUT :id/status {status, reason}
    updateAppointmentStatus(
      rejectAppointmentModal.params?.id as string,
      rejectAppointmentModal.params?.status as number,
      values.reason
    )
      .then(() => {
        message.success(
          t(`messages.successfully_${isCanceled ? 'canceled' : 'rejected'}`)
        );
        closeModal();
        // this modal is mounted globally (App.tsx), outside the appointment
        // detail/patients providers — reload so whichever page opened it
        // reflects the new status (replaces the old cross-query refetch).
        window.location.reload();
      })
      .catch(err => showRestError(err))
      .finally(() => setLoading(false));
  };

  return (
    <Modal
      title={t(
        `appointments_details.${
          rejectAppointmentModal.params?.status ===
          APPOINTMENT_STATUSES.canceled
            ? 'cancel'
            : 'reject'
        }`
      )}
      open={rejectAppointmentModal.visible}
      onOk={form.submit}
      onCancel={closeModal}
      confirmLoading={loading}
    >
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Form.Item
          label={t('appointments_details.enter_reason')}
          name="reason"
          rules={[{ required: true }]}
        >
          <TextArea style={{ height: 130 }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default memo(RejectModal);
